import React from "react";
import { Clock3, FileText, ListChecks } from "lucide-react";
import ExamPanel from "./ExamPanel";

const sectionCards = [
  {
    label: "Section",
    value: "Writing",
    detail: "Summarize Written Text and Write Essay",
    icon: FileText,
  },
  {
    label: "Questions",
    value: "3 tasks",
    detail: "2 summaries and 1 essay",
    icon: ListChecks,
  },
  {
    label: "Time allowed",
    value: "40 minutes",
    detail: "Timer starts when the first writing task begins",
    icon: Clock3,
  },
];

export default function WritingSectionTablePage() {
  return (
    <ExamPanel
      eyebrow="Section overview"
      title="Writing Mock Test"
      instructions={[
        "This focused writing mock follows the same exam layout used in the full mock test.",
        "Read each prompt carefully, write in the response box, then continue with the bottom navigation.",
      ]}
    >
      <div className="grid gap-4 lg:grid-cols-3">
        {sectionCards.map(({ label, value, detail, icon: Icon }) => (
          <div
            key={label}
            className="rounded-md border border-slate-200 bg-slate-50 p-4 ring-1 ring-white"
          >
            <div className="flex items-start gap-3">
              <span className="grid h-10 w-10 shrink-0 place-items-center rounded-md bg-white text-violet-700 shadow-sm ring-1 ring-slate-100">
                <Icon className="h-5 w-5" aria-hidden="true" />
              </span>
              <div className="min-w-0">
                <p className="text-xs font-bold uppercase tracking-wide text-gray-500">
                  {label}
                </p>
                <p className="mt-1 text-xl font-extrabold text-gray-900">
                  {value}
                </p>
                <p className="mt-2 text-sm leading-6 text-gray-600">
                  {detail}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-5 overflow-hidden rounded-md border border-slate-200">
        <div className="grid grid-cols-3 bg-slate-50 px-4 py-3 text-xs font-bold uppercase tracking-wide text-gray-500">
          <span>Part</span>
          <span>Content</span>
          <span>Time</span>
        </div>
        <div className="grid grid-cols-3 px-4 py-4 text-sm font-semibold text-gray-800">
          <span>1</span>
          <span>Writing</span>
          <span>40 minutes</span>
        </div>
      </div>
    </ExamPanel>
  );
}
